/*================================================================================================================
 MAIN CONTROLLER
 ================================================================================================================*/
angular
        .module('vppApp')
        .controller('testController', testController);
        
        testController.$inject = ['$scope', '$rootScope', '$window', 'vppConfig','ProgramInfoService'];

        function testController($scope, $rootScope, $window, vppConfig, ProgramInfoService) {
          ProgramInfoService.checkProgramExists();
          $scope.programId = ProgramInfoService.getProgram();
          $scope.programCode = ProgramInfoService.getProgramCode();
          $scope.pID = $scope.programId;
          console.log(' returned program ID ' + $scope.pID);
          console.log(' returned program Code ' + $scope.programCode);
          
        };


